import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Modal } from 'bootstrap';
import { QuestionService } from '../question-dialog/question-dialog.service';

@Component({
	selector: 'app-simple-component',
	templateUrl: './simple-component.component.html',
	styleUrls: ['./simple-component.component.css'],
})
export class SimpleComponentComponent implements OnDestroy {
	loader = true;
	yesNoQuestion = '';
	private questionSubscription;
	@Input() deleteType = 'archive';
	@Input() selectedElement = {
		id: null,
	};
	@Output() dialogClosed = new EventEmitter();
	@Output() submited = new EventEmitter();
	@Output() deleted = new EventEmitter();

	constructor(private readonly question: QuestionService) {}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	dialogOpen(): void {
		new Modal(document.getElementById('addModal')).show();
	}

	submit(): void {
		this.submited.emit();
	}

	deleteOpen(): void {
		this.ngOnDestroy();
		this.question.ask('Czy na pewno usunąć?', 'deleteAsk');
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'deleteAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.dialogClose();
			this.deleted.emit(result.result);
		});
	}

	ngOnDestroy(): void {
		if (this.questionSubscription) {
			this.questionSubscription.unsubscribe();
		}
	}
}
